import * as S from "./styles.ts";
import { useState } from "react";
import Pages from "./Pages";

export interface IPaginationProps {
  pages: number;
  selectedPage?: number;
  onChange?: (page: number) => void;
}

const Pagination = ({ pages, selectedPage, onChange }: IPaginationProps) => {
  const [currentPage, setCurrentPage] = useState(0);

  const usedPage = selectedPage || currentPage;
  const handleChange = onChange || setCurrentPage;

  return (
    <S.PaginationWrapper>
      <S.PaginationContainer>
        <S.PageNumber
          $disabled={usedPage === 0}
          onClick={() => handleChange(usedPage - 1)}
        >
          Previous
        </S.PageNumber>
        <Pages
          pages={pages}
          selectedPage={usedPage}
          onChange={handleChange}
        />
        <S.PageNumber
          $disabled={usedPage === pages - 1}
          onClick={() => handleChange(usedPage + 1)}
        >
          Next
        </S.PageNumber>
      </S.PaginationContainer>
    </S.PaginationWrapper>
  );
};

export default Pagination;
